import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useClerkAuth } from "../../hooks/use-clerk-auth";
import { useChatbot } from "../../contexts/chatbot-context";
import Header from "../header";
import Footer from "../footer";
import RightPanel from "../right-panel";
import Sidebar from "../sidebar";
import Chatbot from "../chatbot";
import MobileTourNav from "../mobile-tour-nav";
import s from "./styles.module.scss";
import { ReactComponent as ClearLogo } from "../../assets/clearlogo.svg";
import { PUBLIC_HEADER_ROUTS } from "../../static/constants";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const state = useLocation();
  const { user, loading } = useClerkAuth();
  const { isDetached } = useChatbot();
  const isAuthenticated = !!user;
  const isCalendarPage = state.pathname === "/calendar";
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Track window resize for mobile detection
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    console.log("[LAYOUT] =================================");
    console.log("[LAYOUT] Current pathname:", state.pathname);
    console.log("[LAYOUT] Auth loading:", loading);
    console.log("[LAYOUT] User exists:", !!user);
    console.log("[LAYOUT] isAuthenticated:", isAuthenticated);
    console.log("[LAYOUT] =================================");

    if (loading) {
      console.log(
        "[LAYOUT] Authentication still loading, skipping redirect logic"
      );
      return;
    }

    if (!PUBLIC_HEADER_ROUTS.includes(state.pathname) && !isAuthenticated) {
      navigate("/");
    }
  }, [state?.pathname, isAuthenticated, loading, navigate]);

  if (loading && !user) {
    // Simple loading spinner for auth, not the job-polling Loading component
    // Only show if we don't already have user data (prevents flicker on navigation)
    return (
      <div className={s.layoutContainer}>
        <div className={s.authLoading}>
          <div className={s.authCard}>
            <ClearLogo className={s.authLogo} />
            <div className={s.authDots}>
              <div className={s.authDot} />
              <div className={s.authDot} />
              <div className={s.authDot} />
              <div className={s.authDot} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const shouldShowFooter = state.pathname !== '/calendar';
  const shouldShowSidebar = isAuthenticated && !PUBLIC_HEADER_ROUTS.includes(state.pathname) && !isMobile;

  return (
    <div className={s.layoutContainer}>
      <a href="#main-content" className={s.skipLink}>
        Skip to main content
      </a>
      <Header />
      <div className={s.mainArea}>
        <main id="main-content" className={s.mainContent}>{children}</main>
        {shouldShowSidebar && !isCalendarPage && <Sidebar />}
        {shouldShowSidebar && isCalendarPage && <RightPanel />}
      </div>
      {shouldShowFooter && <Footer />}
      {/* Mobile tour navigation - appears at bottom on mobile when tour is active */}
      <MobileTourNav />
      {/* Render detached chatbot outside RightPanel so it persists when sidebar hides */}
      {isCalendarPage && isDetached && <Chatbot />}
    </div>
  );
};

export default Layout;
